import { PulseTourConfig, PulseTourStep } from '@go-modules/services/go-pulse-tour/go-pulse-tour.service';

const TOGGLE_TOUR_KEY = 'activity-task-instructor-toggle-tour';
const PILLS_TOUR_KEY = 'activity-task-instructor-tour';
const TOGGLE_TOUR_STEPS: PulseTourStep[] = [
	{
		completeSelectors: ['.activity-task-toggle'],
		pulse: {
			selectors: ['.activity-task-toggle']
		},
		popover: {
			title: 'activity-task-toggle-tour-title',
			titleIcon: 'ficon-lightbulb-o',
			titleIconColor: '#EDCB50',
			body: 'activity-task-toggle-tour-body',
			completeOnClose: true
		}
	}
];
const PILLS_TOUR_STEPS: PulseTourStep[] = [
	{
		completeSelectors: ['.instructor-overview-pill > button'],
		pulse: {
			selectors: ['.instructor-overview-pill > button']
		},
		popover: {
			title: 'activity-task-toggle-pill-overview-tour-title',
			body: 'activity-task-toggle-pill-overview-tour-body',
			position: 'above'
		}
	},
	{
		completeSelectors: ['.activity-preview-pill > button'],
		pulse: {
			selectors: ['.activity-preview-pill > button']
		},
		popover: {
			title: 'activity-task-toggle-pill-preview-tour-title',
			body: 'activity-task-toggle-pill-preview-tour-body',
			position: 'above'
		}
	}
];

export const ACTIVITY_TASK_INSTRUCTOR_TOGGLE_TOUR_CONFIG: PulseTourConfig = {
	viewTrackKey: TOGGLE_TOUR_KEY,
	steps: TOGGLE_TOUR_STEPS,
	constraints: {
		tourStartDate: new Date('2026-03-01'),
		isOnboarding: false
	}
};

export const ACTIVITY_TASK_INSTRUCTOR_PILLS_TOUR_CONFIG: PulseTourConfig = {
	viewTrackKey: PILLS_TOUR_KEY,
	steps: PILLS_TOUR_STEPS,
	constraints: {
		tourStartDate: new Date('2026-03-01'),
		isOnboarding: false
	}
};
